import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SchemaSEO({ 
    tipo = "LocalBusiness", 
    nombre, 
    descripcion, 
    imagen, 
    calificacionPromedio, 
    totalResenas, 
    url 
}) {
    // Construimos la estructura JSON-LD requerida por Google
    const schema = {
        "@context": "https://schema.org",
        "@type": tipo,
        "name": nombre,
        "description": descripcion,
        "image": imagen,
        "url": url,
    };

    // Solo agregamos el bloque de AggregateRating si el comercio o evento ya tiene reseñas
    if (totalResenas > 0) {
        schema.aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": calificacionPromedio,
            "reviewCount": totalResenas,
            "bestRating": "5",
            "worstRating": "1"
        };
    }

    return (
        <Helmet>
            {/* Meta tags tradicionales para redes sociales (Facebook, WhatsApp, Twitter) */}
            <title>{nombre} | QUD</title>
            <meta name="description" content={descripcion} />
            <meta property="og:title" content={nombre} />
            <meta property="og:description" content={descripcion} />
            <meta property="og:image" content={imagen} />

            {/* El "Hack" SEO: Script JSON-LD para los Rich Snippets de Google */}
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
}